import { createSlice } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import { CLIENT_CODE } from '../../config/LSvars'
import { ticketAlmostExpiredMinutes } from '../../config/const'
import { fetchOrders, fetchQrCart, fetchRoutePrice } from '../thunks/qr'
import { setCurrentTransport } from './select'

const nextDayTimestamp = dayjs().add(1, 'day').startOf('day').valueOf()
// console.log(nextDayTimestamp)

export const qrTickets = [
  {
    id: 'QwertYasd1111',
    city: 'Київ',
    transport: 'Автобус',
    route_id: '50',
    purchaseDate: '12.06.2024 12:24',
    sum: '8',
    timeLeft: nextDayTimestamp,
    qr_data: 'some_qr_data',
  },
  {
    id: 'QwertYasd111',
    city: 'Київ',
    transport: 'Автобус',
    route_id: '50',
    purchaseDate: '12.06.2024 12:24',
    sum: '18',
    timeLeft: dayjs().subtract(ticketAlmostExpiredMinutes, 'minutes').valueOf(),
    qr_data: 'some_qr_data',
  },
  {
    id: 'QwertYasd11',
    city: 'Київ',
    transport: 'Автобус',
    route_id: '50',
    purchaseDate: '12.06.2024 12:24',
    sum: '28',
    timeLeft: dayjs().add(ticketAlmostExpiredMinutes, 'minutes').valueOf(),
    // timeLeft: '32 хвилини',
    qr_data: 'some_qr_data',
  },
]

const initialRouteProps = {
  currentRoute: {},
  from_stop_id: '',
  to_stop_id: '',
  routePrice: {}, // price: 20
}

export const qrSlice = createSlice({
  name: 'qr',
  initialState: {
    qrAmount: 1,
    route_id: '',
    currentRoute: {},
    from_stop_id: '',
    to_stop_id: '',
    routePrice: {}, // price: 0, product_id: 780003,
    totalPrice: 0,
    qrCart: {}, // order_code: 'uuid', client_code: 'uuid',
    orders: qrTickets,
    // orders: [],
  },
  reducers: {
    setQrAmount: (state, { payload }) => {
      state.qrAmount = payload || 1
    },
    setRouteId: (state, { payload }) => {
      return { ...state, ...initialRouteProps, route_id: payload }
    },
    setCurrentRoute: (state, { payload }) => {
      state.currentRoute = payload
    },
    setFromStopId: (state, { payload }) => {
      state.from_stop_id = payload
    },
    setToStopId: (state, { payload }) => {
      state.to_stop_id = payload
    },
    calcTotalPrice: (state, { payload }) => {
      state.totalPrice = state.qrAmount * (state.routePrice?.price || 0)
    },
    setTestTotalPrice: (state, { payload }) => {
      state.totalPrice = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setCurrentTransport, (state, { payload }) => {
        return { ...state, ...initialRouteProps, route_id: '' }
      })
      .addCase(fetchRoutePrice.fulfilled, (state, { payload }) => {
        // console.log('fulfilled')
        state.routePrice = payload?.data || {}
      })
      .addCase(fetchQrCart.fulfilled, (state, { payload }) => {
        // console.log('fulfilled')
        const data = payload?.data || {}
        state.qrCart = data
        const { client_code } = data
        if (client_code) localStorage.setItem(CLIENT_CODE, client_code)
      })
      // .addCase(payWithGoogle.fulfilled, (state, { payload }) => {
      //   // console.log('fulfilled')
      //   state.order = payload?.order || {}
      // })
      .addCase(fetchOrders.fulfilled, (state, { payload }) => {
        state.orders = payload?.data || []
      })
  },
})

// Action creators are generated for each case reducer function
export const {
  setQrAmount,
  setRouteId,
  setCurrentRoute,
  setFromStopId,
  setToStopId,
  calcTotalPrice,
  setTestTotalPrice,
} = qrSlice.actions

export const qrSelector = (state) => state.qr
export const qrReducer = qrSlice.reducer
